// extracted by mini-css-extract-plugin
export default {"return-arrow":"return-arrow_return-arrow__t5exN"};